import React from "react";
import { fileTagsFor } from "../data/portfolio";

export function FileTag({ children, variant = "outline", className = "" }) {
  const v = variant === "blue" ? "ftag--blue" : variant === "ink" ? "ftag--ink" : variant === "lime" ? "ftag--lime" : "";
  return <span className={`ftag ${v} ${className}`}>{children}</span>;
}

export function ProjectTags({ project }) {
  return (
    <span className="inline-flex gap-1.5 flex-wrap">
      {fileTagsFor(project).map((t) => (
        <FileTag key={t}>{t}</FileTag>
      ))}
    </span>
  );
}

export function Chip({ active, children, count, onClick, testid }) {
  return (
    <button className={`chip ${active ? "chip--active" : ""}`} onClick={onClick} data-testid={testid}>
      {children}
      {count != null && <sup style={{ fontSize: 8, marginLeft: 2 }}>{count}</sup>}
    </button>
  );
}
